<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-4 h-4"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.21 0H2.57C2.14 0 1.76 0 1.45 0.04C1.11 0.09 0.76 0.19 0.48 0.47C0.19 0.76 0.09 1.1 0.04 1.44C0 1.75 0 2.13 0 2.55V7.8C0 8.08 0 8.34 0.02 8.55C0.04 8.77 0.09 9.01 0.22 9.24C0.36 9.48 0.57 9.69 0.81 9.83C1.04 9.96 1.5 10.02 1.72 10.04C2 10.98 2.87 11.67 3.91 11.67C4.94 11.67 5.81 10.98 6.09 10.05H8.24C8.52 10.98 9.39 11.67 10.42 11.67C11.46 11.67 12.33 10.98 12.61 10.04C12.84 10.02 13.29 9.96 13.52 9.83C13.77 9.69 13.97 9.48 14.12 9.24C14.25 9.01 14.29 8.77 14.31 8.55C14.33 8.34 14.33 8.08 14.33 7.8V6C14.33 5.78 14.33 5.56 14.27 5.35C14.21 5.13 14.1 4.94 13.99 4.76L12.84 2.86C12.71 2.65 12.6 2.45 12.48 2.29C12.35 2.12 12.2 1.95 11.98 1.83C11.76 1.71 11.54 1.66 11.32 1.64C11.12 1.62 10.89 1.62 10.65 1.62H9.75C9.7 1.28 9.58 0.76 9.3 0.47C9.01 0.19 8.66 0.09 8.33 0.04C8.02 0 7.63 0 7.21 0ZM9.77 7.22C9.98 7.16 10.2 7.13 10.42 7.13C11.46 7.13 12.33 7.81 12.61 8.74C12.91 8.74 13.03 8.55 13.03 8.43V5.69L11.34 2.92H9.77V7.22ZM3.91 8.43C3.37 8.43 2.93 8.86 2.93 9.4C2.93 9.94 3.37 10.37 3.91 10.37C4.45 10.37 4.89 9.94 4.89 9.4C4.89 8.86 4.45 8.43 3.91 8.43ZM9.45 9.4C9.45 8.86 9.88 8.43 10.42 8.43C10.96 8.43 11.4 8.86 11.4 9.4C11.4 9.94 10.96 10.37 10.42 10.37C9.88 10.37 9.45 9.94 9.45 9.4Z"
      :fill="active ? 'url(#truck_blue)' : 'url(#truck_gray)'"
    />
    <defs>
      <linearGradient id="truck_blue" x1="0.65" y1="10.21" x2="12.71" y2="1.34" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C7CBFF" />
        <stop offset="1" stop-color="#0012FA" />
      </linearGradient>
      <linearGradient id="truck_gray" x1="0.65" y1="10.21" x2="12.71" y2="1.34" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#767BA2" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  active?: boolean
}>()
</script>
